import { CoverBackground } from 'components/CoverBackground'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 8px 0 28px 0;
`

const Photo = styled(CoverBackground)`
  border-radius: 10px;
  height: 100%;
`

const Content = styled.div`
  padding: 32px 0 32px 10px;
`

const Suptitle = styled.h6`
  margin-bottom: 14px;
  color: #0078c9;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  text-transform: uppercase;
`

const Title = styled.h1`
  margin: 0;
  padding-bottom: 16px;
  font-size: 26px;
  font-weight: bold;
  line-height: 37px;
`

const Item = styled.div`
  padding: 16px 0;
`

const ItemText = styled.p`
  margin-bottom: 7px;

  :last-of-type {
    margin: 0;
  }
`

const PhoneTag = styled.span`
  padding-right: 10px;
  font-weight: bold;
  color: #0078c9;
`

const Schedule = styled.div`
  padding-top: 48px;
`

const ScheduleTitle = styled.h6`
  margin-bottom: 8px;
  color: #22262a;
  font-size: 15px;
  font-weight: bold;
  line-height: 18px;
`

const ScheduleText = styled.p`
  margin: 0;
  color: #757d88;
  font-size: 15px;
  line-height: 21px;
`

export const IntroDesktop: ComponentType = () => (
  <Wrapper>
    <Container>
      <Row>
        <Col sm={7} lg={8}>
          <Photo url="/images/offices-photo.jpg" />
        </Col>
        <Col sm={5} lg={4}>
          <Content>
            <Suptitle>Contáctanos</Suptitle>
            <Title>Oficinas Yucatán Premier</Title>
            <Item>
              <ItemText>
                <PhoneTag>Ventas</PhoneTag> 999 944-1214
              </ItemText>
              <ItemText>
                <PhoneTag>Rentas</PhoneTag> 999 944-1213
              </ItemText>
            </Item>
            <Item>
              <a href="mailto:info@yucatanpremier.com">info@yucatanpremier.com</a>
            </Item>
            <Item>
              <ItemText>
                Calle 22 No.248 x 27-A <br />
                Fracc. Monterreal <br />
                Mérida, Yucatán, México 97133
              </ItemText>
            </Item>
            <Schedule>
              <ScheduleTitle>Horario de oficina</ScheduleTitle>
              <ScheduleText>
                Lunes a viernes de 9 AM a 7 PM <br />
                Sábados de 9 AM a 1 PM.
              </ScheduleText>
            </Schedule>
          </Content>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
